import React from 'react';
import { BsInfoCircleFill } from 'react-icons/bs';
import AlertInfoProps from './AlertInfoProps';

class AlertInfo extends React.Component<AlertInfoProps, {}> {
    render() {
        return (
            <div className='alert alert-primary d-flex align-items-center' role="alert">
                <BsInfoCircleFill />
                <div className='ml-1' style={{paddingLeft: "10px"}}>
                    {this.props.message}
                </div>
            </div>
        );
    }
}

export default AlertInfo;